module.exports = __webpack_public_path__ + "static/img/tu.a35b093.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/service_mobile/tu.png
// module id = iXV8
// module chunks = 1